import { forwardRef, type ReactNode, type Ref } from 'react';
import { Link, type LinkProps } from '@tanstack/react-router';

/**
 * Renders a Link unless the target entity is soft-deleted — deleted entities
 * stay visible (grayed) but must not navigate to a detail route that would
 * show "not found". Always a single element, so `TooltipTrigger asChild`
 * keeps a valid child; the forwarded ref keeps tooltip positioning working.
 */
export const MaybeLink = forwardRef<
  HTMLAnchorElement | HTMLDivElement,
  LinkProps & { disabled: boolean; children: ReactNode; className?: string }
>(({ disabled, children, className, ...linkProps }, ref) => {
  if (disabled) {
    return (
      <div ref={ref as Ref<HTMLDivElement>} className={className}>
        {children}
      </div>
    );
  }
  return (
    <Link ref={ref as Ref<HTMLAnchorElement>} className={className} {...linkProps}>
      {children}
    </Link>
  );
});
MaybeLink.displayName = 'MaybeLink';
